<div class="n-fieldset">
  <h4 class="n-fieldset-title">
    @if (icon()) {
    <i [class]="icon()"></i>
    }
    {{ title() }}
  </h4>
  <ng-content />
</div>
